import { render, staticRenderFns } from "./PracticeListing.vue?vue&type=template&id=9c632f1a&"
import script from "./PracticeListing.vue?vue&type=script&lang=ts&"
export * from "./PracticeListing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports